import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";

import{ ConsultaSolicitudes, ConsultaDetalles, ConsulEstCuenta, NoAceptarSolicitud, AceptarSolicitud, PagarSolicitud } from "../../funciones/SolicitudesFunction";
import { ConsultVerificacionesInd, ConsultMetodos, ConsultCambio } from '../../funciones/AdministracionFunction';
import { ConsultaDeudaEst, ConsultCuentaAdmin, ConsultaNumCuenta } from "../../funciones/EstCuentaFunction";

import VerificacionPagoTable from "../Administracion/EstadosCuentaContent/VerificacionPagoTable";

import ModalReports from '../../components/Reportes/ModalReports';
import SolicitudRpt from '../../components/Reportes/SolicitudRpt';
import RetiroMateriasAdmin from './RetiroMateriasAdmin';
import RetiroEstudiantes from './RetiroEstudiantes';

let idEst = "";
let idEstD = "";
let CuentaPay = 0;
let errores = 0;
let fecha = new Date();

class AdminSolicitudes extends Component {
    state = {
        tipoSolicitud: { value: '', label: ' - Selecciona un Tipo de Solicitud - ' },
        canSolicitudes: <i className="fa fa-spinner fa-spin"></i>,
        textPreloader: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando Solicitudes"
        },
        listEstudiantes: [],
        asientos: [],
        verificaciones: [],
        boton1: {
            icono: "fa fa-check",
            texto: "Revisar"
        },
        solicitudPreloader: "Selecciona un Estudiante",
        estudiante: "",
        carrAct: "",
        carrCam: "",
        costo: "",
        detalleSolic: {
            est: "",
            carreraAct: "",
            carreraCam: "",
            valorUc: "",
            valorBs: "",
            tipoNota: "",
            fechaSol: "",
            ValorBsNi: ""
        },
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,
        estados: true,
        deudaT: "",
        CuentaPay2: 0,
        boton2:{
            text: "Registrar Pago",
            icon: "fa fa-money"
        },
        boton3:{
            text: "Aprobar",
            icon: "fa fa-check"
        },
        boton4:{
            text: "No Aprobar",
            icon: "fa fa-times"
        },
        modalPagoBtn1: {
            icon:"fa fa-money",
            text: "Registrar",
            disabled: false
        },
        openNoAccept: false,
        openAccept: false,
        openPago: false,
        motivo : {
            text:"",
            mensaje: ""
        },
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        motivo : {
            text:"",
            mensaje: ""
        },
        metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
        metodos: [],
        deudaT: "",
        fecha: fecha,
        otroMonto: "",
        total: true,
        otro: false,
        concepto: "",
        cambio: "",
        divisas: "",
        bsCambio: 0,
        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
        cuentas: [],
        num: "",
        factura: "",
        openWR: false,
    }

    componentWillUnmount = () => {
        idEst = "";
    }

    componentDidMount = () => {
        ConsultMetodos ((resp) => {
            this.setState({
                metodos: resp
            })
        })
        ConsultCambio ((resp) => {
            this.setState({
                cambio: resp
            })
        })
        ConsultaNumCuenta ((resp) => {
            this.setState({
                nuCuenta: resp[0],
                cuentas: resp[1]
            })
        })
    }

    valorSolicitud = (tipoSolicitud) => {
        if (tipoSolicitud.value === "retiro_materias"){
            let pre = "";
            this.setState({
                tipoSolicitud,
                canSolicitudes: <i className="fa fa-spinner fa-spin"></i>,
                textPreloader: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando Solicitudes"
                },
                listEstudiantes: []
            })
        }else if (tipoSolicitud.value === "retiro_estudiantes") {
            let pre = "";
            this.setState({
                tipoSolicitud,
                canSolicitudes: <i className="fa fa-spinner fa-spin"></i>,
                textPreloader: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando Solicitudes"
                },
                listEstudiantes: []
            })
        }else{
            idEst = ""
            this.setState({
                tipoSolicitud,
                canSolicitudes: <i className="fa fa-spinner fa-spin"></i>,
                textPreloader: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando Solicitudes"
                },
                listEstudiantes: []
            }, () => {
                let pre = "";
                ConsultaSolicitudes (tipoSolicitud.label, (resp) => {
                    if (resp.length === 0) pre = "No tienes solicitudes de este tipo"
                    this.setState({
                        listEstudiantes: resp,
                        canSolicitudes: resp.length,
                        textPreloader: {
                            icon: "",
                            text: pre
                        },
                    })
                })
            });
        }
        
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    cambiaValor2 = (prop) => (event) => {
        this.setState({
            [prop]: {
                text: (event.target.value).toUpperCase(),
                mensaje: ""
            }
        });
    };

    cambiaValorM = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    verModalNoAccept = () => () => {
        this.setState({
            openNoAccept: true,
            motivo : {
                text:"",
                mensaje: ""
            }
        })
    }

    verModalAccept = () => () => {
        this.setState({
            openAccept: true,
        })
    }

    valorMetodo = (metodoSelect) => {
        this.setState({
            metodoSelect
        });
    }

    valorCuenta = (selectcuenta) => {
        this.setState({
            selectcuenta
        });
    }

    cambiaValorDivisa = () => (event) => {
        if (!isNaN(Number(event.target.value)) === false) return null;
        let valorCambio = parseFloat(this.state.cambio) * parseFloat(event.target.value)
        if (event.target.value === "") valorCambio = 0;
        this.setState({
            divisas: event.target.value,
            bsCambio: valorCambio.toFixed(2)
        });
    };

    pagar = (prop) => {
        this.setState({
            total: false,
            otro: false,
        }, () => { 
            this.setState({[prop]: true})
        })
    }

    modalAccept = () => {
        const { openAccept, modalAcceptBtn1, tipoSolicitud } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-primary">APROBAR</strong> la solicitud de <strong>{tipoSolicitud.label}</strong> de este Estudiante?</div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Recuerda revisar primero el pago de los aranceles antes de aceptar la solicitud</strong></div>
            </React.Fragment>
        )

        let Aceptar = (id) => (e) => {
            if (this.state.modalAcceptBtn1.disabled === true) return null;

            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            AceptarSolicitud (tipoSolicitud.label, id, () => {
                this.setState ({
                    openAccept: false,
                },() => {
                    idEst = "";
                    toast.info("Has Aceptado correctamente la solicitud del estudiante",{autoClose: 4000});
                    let pre = "";
                    ConsultaSolicitudes (tipoSolicitud.label, (resp) => {
                        if (resp.length === 0) pre = "No tienes solicitudes de este tipo"
                        this.setState({
                            listEstudiantes: resp,
                            canSolicitudes: resp.length,
                            textPreloader: {
                                icon: "",
                                text: pre
                            },
                            modalAcceptBtn1: {
                                icon:"fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                        })
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(idEst)}
                funcion2 = {() => {this.setState({openAccept: false})}}
            />
        );

    }

    modalNoAccept = () => {

        const { openNoAccept, modalNoAcceptBtn1, motivo, tipoSolicitud } = this.state;

        let noAceptar = (id) => (e) => {
            if (this.state.modalNoAcceptBtn1.disabled === true) return null;
            
            if ((motivo.text) === "") {
                this.setState({
                    motivo : {
                        text:"",
                        mensaje: "Indica primero el motivo"
                    }
                })
                return null;
            }

            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            NoAceptarSolicitud (tipoSolicitud.label, id, motivo.text, () => {
                this.setState ({
                    openNoAccept: false,
                    motivo : {
                        text:"",
                        mensaje: ""
                    }
                },() => {
                    idEst = "";
                    toast.info("Has eliminado correctamente la solicitud del estudiante",{autoClose: 4000});
                    let pre = "";
                    ConsultaSolicitudes (tipoSolicitud.label, (resp) => {
                        if (resp.length === 0) pre = "No tienes solicitudes de este tipo"
                        this.setState({
                            listEstudiantes: resp,
                            canSolicitudes: resp.length,
                            textPreloader: {
                                icon: "",
                                text: pre
                            },
                            modalNoAcceptBtn1: {
                                icon:"fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                        })
                    })
                });
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-danger"> NO APROBAR</strong> la solicitud de <strong>{tipoSolicitud.label}</strong> de este Estudiante?</div>
                
                <div className="custom-alert-danger" style={{padding:5}}>
                    <input type="text" value={motivo.text} onChange={this.cambiaValor2("motivo")} className="form-control" placeholder="Indica el motivo"/>
                    <span className="text-danger" style={{fontSize: 12}}>{motivo.mensaje}</span>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(idEst)}
                funcion2 = {() => {this.setState({openNoAccept: false})}}
            />
        );
    }

    modalPago = () => {
        const { openPago, modalPagoBtn1, metodoSelect, metodos, total, otro, otroMonto, deudaT, concepto, fecha,
            cambio, divisas, bsCambio, selectcuenta, cuentas, num, factura, tipoSolicitud
        } = this.state;
        let campos = {metodoSelect, divisas, bsCambio, num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta,
            factura};
        const styles = {
            padding: 2, fontSize: 12
        }

        let montoPayEf = () => (
            <div className="table-responsive">
                <Table bordered style={{marginBottom: 0}}>
                    <tbody>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                            </td>
                        </tr>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )

        let igtf = () => {
            let porcentajeImp =  ((deudaT.totalGral) * (deudaT.igtf)) / 100;
            return porcentajeImp.toFixed(2);
        }

        let totalAPagar = () => {
            return (parseFloat(deudaT.totalGral) + parseFloat(igtf())).toFixed(2);
        }

        let divisaC = () => {
            let valorDiv = totalAPagar() / (cambio);
            return valorDiv.toFixed(2)
        }

        let montoDivisa = () => (
            <React.Fragment>                
                <Row>
                    <Col md = {6}>
                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                        <div className="text-muted" style={{fontSize: 9}}>Sub Total</div>
                    </Col>


                    <Col md = {6}>
                        <input type="text" maxLength= {10} value = {igtf()} disabled className="form-control" placeholder="IGTF" title ="Impuesto a Grandes Transacciones Financeieras"/>
                        <div className="text-muted" style={{fontSize: 9}}>IGTF</div>
                    </Col>
                    <Col md = {12} className = "custom-mt-10">
                        <div className = 'alert custom-alert-danger'>
                            <strong className = 'text-danger' style = {{fontSize: 11}}>
                                <Row>
                                    <Col md = {7}>TOTAL A PAGAR:</Col>
                                    <Col md = {5} align ="right">Bs. {totalAPagar()}</Col>
                                    <Col md = {7}>EN DIVISAS:</Col>
                                    <Col md = {5} align ="right">$ {divisaC()}</Col>
                                </Row>
                            </strong>
                        </div>
                    </Col>


                    <Col md={6}>
                        <input type="number" onChange ={this.cambiaValorDivisa()} value={divisas} className="form-control" placeholder="Ej.: 50"/>
                        <div className="text-muted" style={{fontSize: 9}}>Monto en Divisas ($)</div>  
                    </Col>
                    <Col md={6}>
                        <input type="text" maxLength= {50} disabled value={bsCambio} className="form-control"/>
                        <div className="text-muted" style={{fontSize: 9}}>Equivalencia en Bs.</div>
                    </Col>
                </Row>
                <div className="text-danger" style={{fontSize: 10, marginTop: 5}}>Cambio del dia: <strong>{cambio} Bs por Dólar</strong></div>
            </React.Fragment>
        )

        let conceptoEf = () => (
            <React.Fragment>
                <Col md={12}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
            </React.Fragment>
        )

        let contenidoGral = () => (
            <React.Fragment>
                <Col md={6} className="custom-mt-10">
                    <input maxLength= {20} type="text" value={num} onChange={this.cambiaValorM("num")} className="form-control" placeholder="Ej.: 001828212828"/>
                    <div className="text-muted" style={{fontSize: 9}}>(*) N° de Referencia</div>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
                <Col md={6} className="custom-mt-10 text-danger">(*) Monto:</Col>
                <Col md={6} className="custom-mt-10 text-danger">Concepto:</Col>
                <Col md={6}>
                    <div className="table-responsive">
                        <Table bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={6}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} rows={5} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
            </React.Fragment>
        )

        let contentPay = () => {
            switch (metodoSelect.label) {
                case "EFECTIVO":
                    return(
                        <Row>
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoPayEf()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "DIVISA":
                    return(
                        <Row> 
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoDivisa()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "TRANSFERENCIA":
                    return(
                        <Row>
                            <Col md={12}>
                                <Select
                                    isSearchable ={true}
                                    value={selectcuenta}
                                    onChange={this.valorCuenta}
                                    options={cuentas}
                                />
                                <div className="text-muted" style={{fontSize: 9}}>(*) Seleccciona el número de cuenta al cual hiciste la transferencia</div>
                            </Col>
                            {contenidoGral()}
                        </Row>
                    )
                case "DEBITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                case "CREDITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                default: return (
                    <div className="text-danger" align="center">Selecciona un Método de Pago</div>
                )
            }
        }

        let contenidoModal = () => (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={metodoSelect}
                            onChange={this.valorMetodo}
                            options={metodos}
                        />
                        <div className="text-muted" style={{fontSize: 9}}>Selecciona un Método de Pago</div>
                    </Col>
                    <Col md={6}>
                        <input type="text" value={factura} onChange={this.cambiaValorM("factura")} className="form-control" placeholder="N° de Factura"/>
                        <div className="text-danger" style={{fontSize: 9}}>Número de la Factura</div>
                    </Col>
                </Row>
                <div className="custom-mt-10">{contentPay()}</div>
            </React.Fragment>
        )

        let pagar = () => {
            if (this.state.modalPagoBtn1.disabled === true) return null
            if (metodoSelect.value === "") {
                toast.error("Debes elegir un método de pago",{autoClose: 4000});
                return null;
            }

            this.setState({
                modalPagoBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                PagarSolicitud (idEstD, campos, tipoSolicitud, idEst, (resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            modalPagoBtn1: {
                                icon:"fa fa-check",
                                text:"Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        if (resp[3] === true) {
                            idEstD = "";
                            idEst = "";
                        }
                        this.setState({
                            openPago: false,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: "",
                        }, () => {
                            let pre = "";
                            ConsultaSolicitudes (tipoSolicitud.label, (resp) => {
                                if (resp.length === 0) pre = "No tienes solicitudes de este tipo"
                                this.setState({
                                    listEstudiantes: resp,
                                    canSolicitudes: resp.length,
                                    textPreloader: {
                                        icon: "",
                                        text: pre
                                    },
                                    modalPagoBtn1: {
                                        icon:"fa fa-money",
                                        text: "Registrar",
                                        disabled: false
                                    },
                                })
                            })
                            ConsultaDeudaEst (idEstD, (resp) => {
                                errores = resp.errores;
                                this.setState({deudaT: resp})
                            })
                            ConsultVerificacionesInd (idEstD, (resp)=> {
                                this.setState({verificaciones: resp,})
                            })
                            ConsultCuentaAdmin (idEstD, (resp)=> {
                                this.setState({asientos: resp})
                            })
                        });
                    }
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalPagoBtn1.icon}></i> {modalPagoBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openPago}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Registrar Pago de Aranceles</div>}
                contenido = {contenidoModal()}      
                funcion1 = {pagar}
                funcion2 = {() => {this.setState({openPago: false})}}
            />
        );
    }

    contenido = () => {
        let { tipoSolicitud, canSolicitudes, textPreloader, listEstudiantes, boton1, solicitudPreloader, detalleSolic, iconChevron3,
            estados, asientos, verificaciones, boton2, boton3, boton4, } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }
        const solicitudes = [
            { value: 'cambio_carrera', label: 'Cambio de Carrera' },
            { value: 'notas_cert', label: 'Notas Certificadas' },
            { value: 'constancia_est', label: 'Constancia de Estudios (Simple)' },
            { value: 'retiro_materias', label: 'Retiro de Materias' },
            { value: 'retiro_estudiantes', label: 'Retiro de Estudiantes' },
            { value: 'carta_egreso', label: 'Carta de Egreso' },
            { value: 'carga_horaria', label: 'Carga Horaria' },
            { value: 'pensum_programas', label: 'Certificación Plan de Estudios (Pensum)' },
            { value: 'modalidad_estudios_simple', label: 'Constancia de Modalidad de Estudio (Simple)' },
            { value: 'modalidad_estudios_cert', label: 'Constancia de Modalidad de Estudio (Certificada)' },
            { value: 'culminacion_est', label: 'Constancia de Culminación de Estudios (Simple)' },
            { value: 'culminacion_est_cert', label: 'Constancia de Culminación de Estudios (Certificada)' },
            { value: 'constancia_conducta_cert', label: 'Constancia de Buena Conducta (Certificada)' },
        ];

        let sortJSON = (data, key, orden) => {
            return data.sort(function (a, b) {
                let x = a[key],
                y = b[key];
        
                if (orden === 'asc')  return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                if (orden === 'desc') return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            });
        }

        let listEst = () => {
            if (listEstudiantes.length === 0) return (
                <tr>
                    <td colSpan={2} align="center"><i className={textPreloader.icon}></i> {textPreloader.text}</td>
                </tr>
            )

            return (
                listEstudiantes.map (option => (
                    <tr key = {option.id}>
                        <td style={styles}>
                            <strong>{option.ci}</strong> - {option.estudiante}
                        </td>
                        <td align="center" style={styles}>
                            <button className="btn btn-primary" onClick={() => {
                                this.setState({
                                    boton1: {
                                        icono: "fa fa-spinner fa-spin",
                                        texto: "Espera"
                                    },
                                    solicitudPreloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Detalles</React.Fragment>
                                }, () => {
                                    ConsultaDetalles (option.id, option.id_est, tipoSolicitud.label, (resp) => {
                                        idEst = option.id_est
                                        idEstD = option.id_estD
                                        this.setState({
                                            solicitudPreloader: "",
                                            detalleSolic: {
                                                est: option.estudiante,
                                                carreraAct: resp.carrACt,
                                                carreraCam: resp.carrCam,
                                                valorUc: resp.ValorUc,
                                                valorBs: resp.ValorBs,
                                                ValorBsNi: resp.ValorBsNi,
                                                tipoNota: resp.tipoNota,
                                                fechaSol: resp.fecha
                                            },
                                            boton1: {
                                                icono: "fa fa-check",
                                                texto: "Revisar"
                                            }
                                        })
                                    })

                                    ConsulEstCuenta (option.id_estD, (resp) => {
                                        CuentaPay = resp[0];
                                        this.setState({CuentaPay2: resp[0]})
                                    })

                                    ConsultaDeudaEst (option.id_estD, (resp) => {
                                        errores = resp.errores;
                                        this.setState({deudaT: resp})
                                    })
                                    ConsultVerificacionesInd (option.id_estD, (resp)=> {
                                        this.setState({verificaciones: resp,})
                                    })
                                    ConsultCuentaAdmin (option.id_estD, (resp)=> {
                                        this.setState({asientos: resp})
                                    })
                                })
                            }} style={{borderWidth: 1}} title="Revisar esta solicitud"><i className={boton1.icono}></i> {boton1.texto}</button>
                        </td>
                    </tr>
                ))
            )
        }

        let solicitudDetalle = () => {
            if (idEst === "") return (
                <div className="text-danger" align="center">{solicitudPreloader}</div>
            )

            switch (tipoSolicitud.label) {
                case "Cambio de Carrera":
                    return(
                        <React.Fragment>
                            <div className="custom-alert-info">Detalles de la Solicitud {solicitudPreloader}</div>
                            <Row className="custom-mt-10" style={{padding:5}}>
                                <Col md={5}>
                                    <strong>Tipo de Solicitud:</strong> {tipoSolicitud.label}
                                </Col>
                                <Col md={7}>
                                    <strong>Estudiante:</strong> {detalleSolic.est}
                                </Col>
                                <Col md={5}>
                                    <strong>Carrera Actual:</strong> <span className="text-info">{detalleSolic.carreraAct}</span>
                                </Col>
                                <Col md={7}>
                                    <strong>Cambio para:</strong> <span className="text-danger">{detalleSolic.carreraCam}</span>
                                </Col>
                                <Col md={12} align="right" className="pull-right">
                                    <div className="custom-alert-danger">Costo de la solicitud: <strong className="text-danger">{detalleSolic.valorUc} U.C.</strong> 
                                        <div><strong className="text-danger">Regulares: {(detalleSolic.valorBs).toFixed(2)} Bs. | Nuevo Ingreso: {(detalleSolic.ValorBsNi).toFixed(2)} Bs.</strong></div>
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                case "Notas Certificadas":
                    return(
                        <React.Fragment>
                            <div className="custom-alert-info">Detalles de la Solicitud {solicitudPreloader}</div>
                            <Row className="custom-mt-10" style={{padding:5}}>
                                <Col md={5}>
                                    <strong>Tipo de Solicitud:</strong> {tipoSolicitud.label}
                                </Col>
                                <Col md={7}>
                                    <strong>Estudiante:</strong> {detalleSolic.est}
                                </Col>
                                <Col md={12}><strong>Tipo de Notas:</strong> {detalleSolic.tipoNota}</Col>
                                <Col md={12} align="right" className="pull-right">
                                    <div className="custom-alert-danger">Costo de la solicitud: <strong className="text-danger">{detalleSolic.valorUc} U.C.</strong>
                                        <div><strong className="text-danger">Regulares: {(detalleSolic.valorBs).toFixed(2)} Bs. | Nuevo Ingreso: {(detalleSolic.ValorBsNi).toFixed(2)} Bs.</strong></div>
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                case "Constancia de Estudios (Simple)":
                    return(
                        <React.Fragment>
                            <div className="custom-alert-info">Detalles de la Solicitud {solicitudPreloader}</div>
                            <Row className="custom-mt-10" style={{padding:5}}>
                                <Col md={5}>
                                    <strong>Tipo de Solicitud:</strong> {tipoSolicitud.label}
                                </Col>
                                <Col md={7}>
                                    <strong>Estudiante:</strong> {detalleSolic.est}
                                </Col>
                                <Col md={12}><strong>Fecha de la Solicitud:</strong> {detalleSolic.fechaSol}</Col>
                                <Col md={12} align="right" className="pull-right">
                                    <div className="custom-alert-danger">Costo de la solicitud: <strong className="text-danger">{detalleSolic.valorUc} U.C.</strong>
                                        <div><strong className="text-danger">Regulares: {(detalleSolic.valorBs).toFixed(2)} Bs. | Nuevo Ingreso: {(detalleSolic.ValorBsNi).toFixed(2)} Bs.</strong></div>
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                default: return (
                    <React.Fragment>
                        <div className="custom-alert-info">Detalles de la Solicitud {solicitudPreloader}</div>
                        <Row className="custom-mt-10" style={{padding:5}}>
                            <Col md={5}>
                                <strong>Tipo de Solicitud:</strong> {tipoSolicitud.label}
                            </Col>
                            <Col md={7}>
                                <strong>Estudiante:</strong> {detalleSolic.est}
                            </Col>
                            <Col md={12}><strong>Fecha de la Solicitud:</strong> {detalleSolic.fechaSol}</Col>
                            <Col md={12} align="right" className="pull-right">
                                <div className="custom-alert-danger">Costo de la solicitud: <strong className="text-danger">{detalleSolic.valorUc} U.C.</strong>
                                    <div><strong className="text-danger">Regulares: {(detalleSolic.valorBs).toFixed(2)} Bs. | Nuevo Ingreso: {(detalleSolic.ValorBsNi).toFixed(2)} Bs.</strong></div>
                                </div>
                            </Col>
                        </Row>
                    </React.Fragment>
                )
            }
        }

        let EstadoCuenta = () => {
            
            let contentEstado = () => {
                let bs = (monto) => {
                    let bs = `${monto} Bs.`;
                    if (monto === "" || monto === null) bs = "";
                    return bs;
                }

                let icono = (mess, status) => {
                    let icono = <i className="fa fa-check-circle text-success"></i>;
                    if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                    if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                    return icono;
                }

                let status = (mess, status) => {
                    let styles = {color:"#000"}
                    if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                    if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                    return styles;
                }

                let aviso = (mess, status) => {
                    let aviso = "";
                    if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                    if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                    return aviso;
                }

                return (
                    asientos.map(option => (
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                            <td align="center" style={styles}>{bs(option.debe)}</td>
                            <td align="center" style={styles}>{bs(option.haber)}</td>
                            <td align="center" style={styles}>{option.saldo} Bs.</td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    ))
                )
            }

            let pagos = () => (
                verificaciones.map(option => (
                    <VerificacionPagoTable key={option.id} datos={option} updList = {() => {
                        this.setState({
                            openNoAccept: false,
                            openAccept: false,
                            openPago: false,
                        }, () => {
                            ConsultVerificacionesInd (idEstD, (resp)=> {
                                this.setState({verificaciones: resp,})
                            })
                            ConsultCuentaAdmin (idEstD, (resp)=> {
                                this.setState({asientos: resp})
                            })
                            ConsultaDeudaEst (idEstD, (resp) => {
                                errores = resp.errores;
                                this.setState({deudaT: resp})
                            })
                        })
                    }}/>
                ))
            )

            let pays = () => {
                if (CuentaPay === 0) return null;

                return(
                    <div className="custom-alert-info custom-mt-10" style={{padding: 2}}>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "30vh", overflowX:"hidden"}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                        <td width="60%%" style={styles}><strong>Detalles del Pago</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {pagos()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )
            }

            return (
                <React.Fragment>
                    <div className="table-responsive" style={{overflowY: "auto", maxHeight:"30vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="10%" align="center"style={styles}><strong>N°</strong></td>
                                    <td width="10%" align="center"style={styles}><strong>Fecha</strong></td>
                                    <td width="40%" style={styles}><strong>Descripción</strong></td>
                                    <td width="12%" align="center" style={styles}><strong>Facturado</strong></td>
                                    <td width="12%" align="center" style={styles}><strong>Pagado</strong></td>
                                    <td width="16%" align="center" style={styles}><strong>Balance</strong></td>
                                    <td width="30px" align="center" style={styles}></td>
                                </tr>
                                {contentEstado()}
                            </tbody>
                        </Table>
                    </div>
                    {pays()}
                </React.Fragment>
            )
        }

        let estadoDeCuenta = () => {
            if (idEst === "") return null;

            return (
                <Row>
                    <Col md={12}>
                        <PanelGroup accordion activeKey={estados} className="custom-alert-info">
                            <Panel eventKey = {true}>
                                <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estados")}}>
                                    <Panel.Title toggle className="custom-color">
                                        <Row>
                                            <Col md={10} style={{fontSize: 12}}>
                                                Estado de Cuenta
                                            </Col>
                                            <Col md={2} align="right">
                                                <i className={iconChevron3}></i>
                                            </Col>
                                        </Row>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                    {EstadoCuenta()}
                                </Panel.Body>
                            </Panel>
                        </PanelGroup>
                    </Col>
                </Row>
            )
        }

        let botones = () => {
            if (idEst === "") return null;
            
            return (
                <Row>
                    <Col md = {12} className="custom-mt-10" align="right">
                        <button className="btn btn-warning" onClick = {
                                () => {
                                    this.setState({
                                        openPago: true,
                                        otroMonto: "",
                                        total: true,
                                        otro: false,
                                        concepto: "",
                                        divisas: "",
                                        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                                        metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                                        num: "",
                                        modalPagoBtn1: {
                                            icon:"fa fa-money",
                                            text: "Registrar"
                                        },
                                    })
                                }}

                        title="Registrar pago" style={{borderWidth: 1, marginRight: 5}}><i className={boton2.icon}></i> {boton2.text}</button>
                        <button className="btn btn-primary" onClick = {this.verModalAccept()} style={{borderWidth: 1, marginRight: 5}}><i className={boton3.icon}></i> {boton3.text}</button>
                        <button className="btn btn-danger" onClick = {this.verModalNoAccept()} style={{borderWidth: 1}}><i className={boton4.icon}></i> {boton4.text}</button>
                    </Col>
                </Row>
            )
        }

        let detalleSolicitud = () => {
            if (tipoSolicitud.value === "") return (
                <div className="text-danger" align="center">Selecciona un <strong>Tipo de Solicitud</strong> para continuar</div>
            )

            switch(tipoSolicitud.value){
                case "": return (
                    <div className="text-danger" align="center">Selecciona un <strong>Tipo de Solicitud</strong> para continuar</div>
                )
                case "retiro_materias": return(
                    <RetiroMateriasAdmin />
                )
                case "retiro_estudiantes": return(
                    <RetiroEstudiantes />
                )
                default: return(
                    <React.Fragment>
                        <div className="custom-alert-info" style={{padding: 5}}>
                            <Row>
                                <Col md={8}>
                                    <div style={{marginTop: 10}}><i className="fa fa-edit"></i> Solicitudes de <strong>{tipoSolicitud.label}</strong> pendientes ({canSolicitudes})</div>
                                </Col>
                                <Col md={4} align="right">
                                    <button className="btn btn-relleno-primary" onClick={() => {this.setState({openWR: true})}} title="Imprimir el listado" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                                </Col>
                            </Row>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color-warning">
                                        <td width="100%" style={styles}><strong>Estudiante</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {listEst()}
                                </tbody>
                            </Table>
                        </div>
                        <div className="custom-mt-10">{solicitudDetalle()}</div>
                        <div className="custom-mt-10">{estadoDeCuenta()}</div>
                        <div className="custom-mt-10">{botones()}</div>
                    </React.Fragment>
                )
            }
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">
                    <Row>
                        <Col md={5} style={{marginTop: 10, paddingLeft: 20}}>
                            Selecciona el tipo de Solicitud
                        </Col>
                        <Col md={7}>
                            <Select
                                isSearchable ={true}
                                value={tipoSolicitud}
                                onChange={this.valorSolicitud}
                                options={sortJSON(solicitudes, 'label', 'asc')}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="custom-mt-10">
                    {detalleSolicitud()}
                </div>
            </React.Fragment>
        )
    }

    modalReporte = () => {
        let { openWR, tipoSolicitud, listEstudiantes } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<SolicitudRpt tipo = {tipoSolicitud} datos = {listEstudiantes}/>}
                titulo={`Solicitudes de ${tipoSolicitud.label}`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En este módulo puedes ver las solicitudes que hacen los estudiantes. También puedes ver el costo de la solicitud y si el estudiante efectuó la transferencia. Para continuar debes realizar los siguientes pasos:
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
            </Col>
            <Col md={12} align="justify">
                Selecciona el <strong>Tipo de Solicitud</strong>. En caso de que no exista ninguna verás el siguiente mensaje: <em>"No tienes solicitudes de este tipo"</em>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
            </Col>
            <Col md={12} align="justify">
                Te aparecerá una lista de estudiantes pendientes con la solicitud seleccionada. Elige uno y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i> Revisar</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Al presionar el botón te aparecerán los detalles de la solicitud y el estado de cuenta del estudiante.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10" style={{fontSize:11}}>
                <strong>En caso de que el estudiante haya realizado un abono o pago aparecerán los detalles el cual puedes aprobar o no mediante el botón</strong> <button className="btn btn-primary btn-sm" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
            </Col>
            <Col md={12} align="justify">
                Presiona cualquiera de los siguientes botones:
            </Col>
            
            <Col md={5} className="custom-mt-10" align="right">
                <button className="btn btn-warning btn-sm" style={{borderWidth:1}}><i className="fa fa-money"></i> Registrar Pago</button>
            </Col>
            <Col md={7} align="justify" className="custom-mt-10">
                Este botón permite registrar el pago de los aranceles de la solicitud.
            </Col>
            <Col md={5} className="custom-mt-10" align="right">
                <button className="btn btn-primary btn-sm" style={{borderWidth:1}}><i className="fa fa-check"></i> Aprobar</button>
            </Col>
            <Col md={7} align="justify" className="custom-mt-10">
                Este botón aprueba la solicitud para que <strong>Control de Estudios</strong> pueda efectuar la impresión.
                <div style={{fontSize: 11}}><strong className="text-danger">Importante: Este botón presiónalo solo cuando hayas revisado correctamente el pago de los aranceles</strong></div>
            </Col>
            <Col md={5} className="custom-mt-10" align="right">
                <button className="btn btn-danger btn-sm" style={{borderWidth:1}}><i className="fa fa-times"></i> No Aprobar</button>
            </Col>
            <Col md={7} align="justify" className="custom-mt-10">
                Este botón anula la solicitud del estudiante y <strong>Control de Estudios</strong> no podrá procesar la solicitud.
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                En ambos casos (Aprobar y No Aprobar) se le enviará una notificación al email del estudiante
            </Col>

        </Row>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div>
                            <CustomCard
                                title="Solicitudes"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Solicitudes</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalAccept()}
                {this.modalNoAccept()}
                {this.modalPago()}
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default AdminSolicitudes;


// WEBPACK FOOTER //
// ./src/views/Administracion/AdminSolicitudes.jsx